import { Box, type BoxProps } from '../box';

interface FormProps extends React.HTMLAttributes<HTMLFormElement> {
  sx?: BoxProps['sx'];
}

function Form(props: Readonly<FormProps>) {
  const { children, ...restProps } = props;
  return (
    <Box component='form' noValidate {...restProps}>
      {children}
    </Box>
  );
}

export { Form };
export type { FormProps };
